<template>
  <div class="plateorder">
    <div class="plateorder-tabs vue_flex vue_flex_between vue_align_center">
      <div class="plateorder-tabs-input vue_flex vue_align_center">
        <div class="top_bar_inp vue_flex vue_align_center">
          <img
            class="top_bar_inp_img1 h"
            src="../../../../../assets/yimou/ss.png"
            alt=""
            @click="getHetongListFun"
          />
          <input
            type="text"
            class="top_bar_inp_inp"
            v-model="searchValue"
            placeholder="输入指标名称查询"
          />
        </div>
        <!-- <div class="shaixuan_item vue_flex vue_align_center h">
          <div class="shaixuan_item_con vue_flex vue_align_center">
            <p class="vue-font-PingFang-500 color_35">目标月份</p>
          </div>
          <div class="shaixuan_item_con vue_flex vue_align_center">
            <p class="vue-font-PingFang-500 color_153">请输入</p>
            <p class="vue-font-PingFang-500 color_153">~</p>
            <p class="vue-font-PingFang-500 color_153">请输入</p>
          </div>
        </div> -->
      </div>
      <div
        class="plateorder-tabs-input-but vue-font-PingFang-500 color_255 h"
        v-if="!editState"
        @click="editState = true"
      >
        编辑目标
      </div>

      <div class="vue_flex vue_align_center" v-if="editState">
        <div
          class="plateorder-tabs-piye-but vue-font-PingFang-500 color_35 h"
          @click="editClick"
        >
          取消
        </div>
        <div
          class="plateorder-tabs-input-but vue-font-PingFang-500 color_255 h"
          @click="applyList"
        >
          保存
        </div>
      </div>
    </div>

    <div class="width_100" style="margin-top: 28px">
      <el-table
        :data="dataList"
        style="width: 100%"
        :header-cell-style="headercellstyle"
        border
        height="70vh"
        :key="'taobaoTable'"
      >
        <el-table-column
          prop="zhibiaomingcheng"
          label="指标名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="zhibiaomulu"
          label="指标目录"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="manageame"
          label="指标释义"
          align="center"
          width="430px"
        >
          <template slot-scope="row">
            <div v-if="!editState">
              {{ row.row.text }}
            </div>
            <div v-if="editState">
              <div v-if="row.row.zhibiaoshiyizhong == ''">
                {{ row.row.zhibiaoshiyiqian }}
                <input
                  style="width: 114px; height: 50px; background: #f4f5f9"
                  type="text"
                  v-model="row.row.zhibiao1"
                  placeholder="请输入"
                />
                {{ row.row.zhibiaoshiyihou }}
              </div>
              <div v-else>
                {{ row.row.zhibiaoshiyiqian }}
                <input
                  style="width: 114px; height: 50px; background: #f4f5f9"
                  v-model="row.row.zhibiao1"
                  placeholder="请输入"
                />
                {{ row.row.zhibiaoshiyizhong }}
                <input
                  style="width: 114px; height: 50px; background: #f4f5f9"
                  type="text"
                  v-model="row.row.zhibiao2"
                  placeholder="请输入"
                />
                {{ row.row.zhibiaoshiyihou }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="uploadtime"
          label="最后一次操作时间"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column
          v-for="month in visibleMonths"
          :key="month"
          :label="`${month}目标`"
          align="center"
          width="130px"
        >
          <template slot-scope="scope">
            <span v-if="!editState"
              >销售收入: {{ scope.row[month] || "-" }}</span
            >
            <div class="vue_flex vue_align_center" v-else>
              <span>销售收入: </span>
              <input
                type="text"
                v-model="scope.row[month]"
                class="synthet-input"
              />
            </div>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { windowFun } from "@/utils/utils";
import DonMessage from "@/utils/message";
import Cookies from "js-cookie";
export default {
  components: { Pagination },
  data() {
    return {
      innerWidth: 0,
      innerHeight: 0,
      headercellstyle: {
        backgroundColor: "rgba(245, 247, 250, 1)",
        color: "rgba(51, 3, 0, 1)",
      },

      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },

      dialogimportVisible: false,

      wenzi: "",
      searchValue: "",
      dataList: [],

      options: [
        { value: "选项1", label: "黄金糕" },
        { value: "选项2", label: "双皮奶" },
        { value: "选项3", label: "蚵仔煎" },
        { value: "选项4", label: "龙须面" },
        { value: "选项5", label: "北京烤鸭" },
      ],
      tempObj: {
        channelVal: "",
        typeVal: "",
      },

      visibleMonths: [],
      dateRange: ["2025-01", "2025-21"], // 绑定日期选择器的范围，格式：[开始月, 结束月]，如 ['2025-01', '2025-05']
      editState: false,
    };
  },

  created() {
    this.getHetongListFun();
    this.innerWidth = windowFun().innerWidth;
    this.innerHeight = windowFun().innerHeight;
    const [startMonth, endMonth] = this.dateRange;
    this.visibleMonths = this.generateMonths(startMonth, endMonth);
  },

  methods: {
    async callApi(data) {
      await this.$http.get(this.$urls.editZhibiao, data);
      return;
    },
    async applyList() {
      const promises = [];
      for (let i in this.dataList) {
        let params = {
          id: this.dataList[i].id,
          zhibiao1: this.dataList[i].zhibiao1,
          zhibiao2: this.dataList[i].zhibiao2,
        };
        promises.push(this.callApi(params));
      }
      const results = await Promise.all(promises);
      this.editState = false;
      this.getHetongListFun();
    },
    async getHetongListFun() {
      let params = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
        name: this.searchValue,
      };
      const res = await this.$http.get(this.$urls.getZhibiaoList, params);
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.dataList = res.list;
    },
    editClick() {
      this.editState = false;
    },

    // 3. 日期选择变化时，筛选需要显示的月份列
    handleDateChange(range) {
      if (!range || range.length !== 2) {
        this.visibleMonths = [];
        return;
      }
      const [startMonth, endMonth] = range;
      this.visibleMonths = this.generateMonths(startMonth, endMonth);
    },

    // 4. 生成两个月份之间的所有年月（如 2025-01 到 2025-05 → ['2025-01', '2025-02', ..., '2025-05']）
    generateMonths(start, end) {
      const months = [];
      const startYear = parseInt(start.split("-")[0]);
      const startMonth = parseInt(start.split("-")[1]);
      const endYear = parseInt(end.split("-")[0]);
      const endMonth = parseInt(end.split("-")[1]);

      let currentYear = startYear;
      let currentMonth = startMonth;

      while (
        currentYear < endYear ||
        (currentYear === endYear && currentMonth <= endMonth)
      ) {
        const monthStr = `${currentYear}-${currentMonth
          .toString()
          .padStart(2, "0")}`;
        months.push(monthStr);

        currentMonth++;
        if (currentMonth > endMonth) {
          currentYear++;
          currentMonth = 1;
        }
      }
      return months;
    },
  },
};
</script>

<style lang="scss" scoped>
.plateorder {
  padding: 22px;
}
.plateorder-tabs {
  background: rgba(245, 245, 245, 1);
  border-radius: 10px;
  padding: 9px 18px 8px 47px;
  .plateorder-tabs-input {
    .shaixuan_item {
      width: 350px;
      height: 54px;
      background: #ffffff;
      border-radius: 10px;
      padding: 0 20px;
      margin-right: 22px;
      .shaixuan_item_con {
        p {
          font-size: 18px;
        }
        .shaixuan_item_arr {
          width: 13px;
          height: 8px;
          margin-left: 10px;
        }
        .shaixuan_item_icon {
          width: 29px;
          height: 24px;
          margin-right: 10px;
        }
      }

      .shaixuan_item_con:nth-of-type(2) {
        margin-left: 57px;
        p:nth-of-type(2) {
          margin: 0px 20px;
        }
      }
    }

    .top_bar_inp {
      width: 372px;
      height: 54px;
      background: rgba(255, 255, 255, 1);
      border-radius: 10px;
      margin-right: 32px;
      padding: 0 11px;
      .top_bar_inp_img1 {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }
      .top_bar_inp_inp {
        width: 282px;
        font-size: 17px;
        line-height: 17px;
      }
    }
  }
  .plateorder-tabs-piye-but {
    width: 138px;
    height: 55px;
    line-height: 53px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid rgba(153, 153, 153, 1);
    font-size: 20px;
    margin-right: 26px;
  }
  .plateorder-tabs-input-but {
    width: 131px;
    height: 54px;
    background: rgba(25, 92, 248, 1);
    border-radius: 10px;
    font-size: 20px;
    line-height: 54px;
    text-align: center;
  }
}

.import-mask {
  width: 100%;
  border-radius: 15px;
  background-image: url("../../../../../assets/yimou/tb.png");
  background-size: 100% 51px;
  background-repeat: no-repeat;
  padding-bottom: 40px;
  .import-mask-title {
    width: 100%;
    height: 51px;
    line-height: 51px;
    text-align: center;
    font-size: 18px;
    img {
      width: 13px;
      height: 13px;
      top: 21px;
      right: 20px;
    }
  }
  .import-mask-boxs {
    width: 650px;
    margin-top: 34px;
    .import-mask-boxs-inp {
      width: 100%;
      background: rgba(245, 245, 245, 1);
      border-radius: 10px;
      padding: 11px 22px;
      margin-bottom: 19px;
      ul {
        li:nth-of-type(1) {
          width: 145px;
          font-size: 18px;
          line-height: 18px;
          span {
            color: rgba(255, 0, 0, 1);
          }
        }
      }
    }
    .import-mask-boxs-upload {
      width: 100%;
      height: 168px;
      margin: 10px 0px 34px;
      background-image: url("../../../../../assets/yimou/hsk.png");
      img {
        width: 35px;
        height: 31px;
        margin-top: 39px;
      }
      .upload-title {
        font-size: 16px;
        line-height: 16px;
        margin: 16px 0px 13px;
        span:nth-of-type(2) {
          color: rgba(20, 75, 201, 1);
        }
      }
      .upload-content {
        font-size: 14px;
        line-height: 14px;
      }
    }
    .import-mask-ul-boxs {
      width: 24vw;
    }
  }
  .import-mask-but {
    width: 266px;
    height: 47px;
    line-height: 47px;
    text-align: center;
    background: rgba(25, 92, 248, 1);
    border-radius: 10px;
    font-size: 17px;
  }
}

.plateorder-type {
  margin: 23px 0px;
  div {
    width: 155px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border-radius: 10px;
    margin-right: 14px;
  }
  .active {
    color: rgba(255, 255, 255, 1);
    background: rgba(25, 92, 248, 1);
  }
  .activenot {
    color: rgba(35, 35, 35, 1);
    background: rgba(245, 245, 245, 1);
  }
}

.el-select {
  width: 100% !important;
}
.el-select /deep/.el-input__inner {
  width: 100%;
  border: none !important;
  background: none !important;
  font-size: 18px;
}
.el-select /deep/.el-select__caret {
  color: #000000 !important;
}

.synthet-input {
  background: rgba(243, 243, 243, 1);
  padding: 5px;
  width: 45px;
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/targetset/synthetical/index.vue